import Component from './contact'

export default Component